import React, { Component, PropTypes } from 'react';
import { FontIcon, Divider } from 'material-ui';

class StepperWizard extends Component {
	constructor(props) {
		super(props);
		this.state = this._populateState(props);
	}

	_populateState(props) {
		const steps = props.steps || [];
		const componentIndex = props.componentIndex || 0;
		return {
			componentIndex,
			stepperState: steps.map((step, index) => {
				return {
					name: step,
					selected: index === componentIndex,
					finished: index < componentIndex,
				};
			}),
		};
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.componentIndex !== nextProps.componentIndex) {
			this.setState(this._populateState(nextProps));
		}
	}

	render() {
		const getPossibleState = (selected, finished) => {
			if (finished) return 'done';
			if (selected) return 'doing';
			return 'todo';
		};
		const { stepperState, componentIndex } = this.state;
		const { children, steps, showStepsBar } = this.props;
		return (
			<div className="stepper-container" style={{ boxShadow: 'none', padding: showStepsBar ? '17px' : '0px' }}>
				{
					showStepsBar ?
						<div className="stepper-body">
							{
								stepperState.map(({ finished, name, selected }, index) => {
									const [containerWidth, lineWidth, margin]  = (() => {
										if (stepperState.length === 3) {
											if (stepperState.length === index + 1) return ['20%', '0', '5%'];
											return ['35%', '40%', '5%'];
										}
										if (stepperState.length === 4) {
											if (stepperState.length === index + 1) return ['25%', '0', '2%'];
											return ['28%', '20%', '2%'];
										}
										if (stepperState.length === index + 1) return ['35%', '60%', '5%'];
										return ['85%', '60%', '5%'];
									})();
									const firstMarginLeft = (() => {
										if (index > 0) return margin;
										if (stepperState.length  === 2) return '10%';
										return '0';
									})();
									return (
										<div className="step-container" key={index} style={{ width: containerWidth, marginLeft: firstMarginLeft }}>
											<div className="stepper-body">
												<div style={{ width: '24px', height: '24px', borderRadius: '50%', textAlign: 'center', lineHeight: '20px', display: 'inline-block', float: 'left',
	                backgroundColor: getPossibleState(selected, finished) !== 'todo' ? '#00BCD4' : '#BDBDBD'}}
												>
													{finished ? <FontIcon className="tc-icon-check" color="white" style={{ fontSize: '14px', fontWeight: 'bold', top: '2px' }} /> : <span style={{ color: 'white', fontSize: '15px', lineHeight: '24px' }}>{index + 1}</span>}
												</div>
												<span className="step-title">{name}</span>
												{stepperState.length !== index + 1 ? <span className="step-grey-line" style={{ width: lineWidth }} /> : undefined }
											</div>
										</div>
									);
								})
							}
						</div> :
						(
							!steps[componentIndex] ? undefined :
							<div
							style={{
							backgroundColor: '#00BCD4',
							color: 'white',
							fontSize: '18px',
							padding: '2%',
						}}
							>
							{steps[componentIndex]}
							</div>
						)
				}
				{
					showStepsBar ? <Divider style={{ marginTop: '20px' }} /> : undefined
				}
				<div className="contracting-paper-body">
					{children[componentIndex]}
				</div>
			</div>
		);
	}
};

StepperWizard.propTypes = {
	componentIndex: PropTypes.number.isRequired,
	steps: PropTypes.array,
};

export default StepperWizard;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/stepper-wizard.jsx